
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexQxU189etSXSifs4L_rQJBT_45QBFxjDi0_45smtpnVUkWf4Meta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debugiz2qZwl5cYKIuMzHIZixELIaxPcXokRdKPtYWTBxv5AMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginXzFbQFoN0qZwLts5W3vfAeg2T05NsdmmtwmoGrbpnJ8Meta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signupQCVimxnOy4SARnHC2r4P9kYjLnTSGki0Bpg_5ONmLUkMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPasswordqzn3YZFmOUVO_9trW4Zyc_t0VOQjvHRYe_45qgoiWVjsIMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordYK_45aTBHRCfPKNBHW3h6nfVkkFUR1XNuA_45C8Vj4yT8IgMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmailAo8kLZEGbT_45XW9OZ_Q5ms883I4iIGPnjgo0VZ3SzYRMMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddressexG3EQl6lRFA9KG9qpt7MMtzYVMwVAV2w1F3oo8RQ24Meta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuideYsbRPpAPCdsp8hycbpX4z1qk_6kS8Kvdl8x34mhhKZwMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginPages2_rQmbcC1vrj_zgkfZIrs_4npIvdjvcsJ6DRNZh_45AXAMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardHmYdgJziaUC0eR2IytLRDnfiCVPH4LQMAC7Q7L5B26EMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspacewxZhMjbyofOljqfQuvSg8IYQDfk_A9io5UZZjIACBykMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsXWoorFrgD94i0xpOsANmv2hS6Z1Bcm2yx1oWbo_45uFlAMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as healthrB9qzLR_yuvkOkbO_45z1b0d_gMAaW1yAZXMzxV8NqUOQMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardJzKFmDbRbr0UJjW7hohY5T44L0VD7Nyopt2fjUNepQwMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as users2_45g2BN_45f1iyPOML7db_45jWpv1zqqZSIozCkfGXHuXpTEMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspacesTX_BJlt5l8nQHXWY8GmPEVu42AaM7HPEfM_45taNuVbtQMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as membersdE5cVBMEgmF8bJA_45Wrw5EqhuZDgIj9nNObbv6NGMryIMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invitespXOoSFBrTZ28wVkS33pXOnzU1ly42FibSCtC_45BKuzJoMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as settingsn96uSAuWjJ2IOYwiW3nUgX81n9k3KJPgkubN8qaTTwMMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as rootO78EjDlWRB58aLvJb4SZt_45g3x3OMxmAkyKy_45sOzDHBcMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitationYfxSL0P_45YMo_L5ssEElLpjkOw3D5bru2AKDYXSppPiAMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as template_45wXht3_45PEQar9gisI4086qqur20zL9AAeqZbagJWox4Meta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as _health1inQGDXoblBX0rm6OKbjV8az6WTTrf_45dwjkNknxPBkYMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectFOiWGEtrl187_iXchn3gULHh6JmjhCmfpvoZBDag_joMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingQHwVSXgnlyvQHccWhAEGxullQptF4c7t9AcooYfcTbMMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholder_BfoDN1naOqDAwxBJd2RTAyB3JzG6FLGkGVUGvEkMyoMeta } from "/var/www/baserow/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhookssJGnQXS9_45uNFM5PeCs0p2lM6ZIhn06aWKOLwe8jB1BMMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSynctymXNXDE2iuO_Yf9FMuFBjCsG655Ga8tekBKZQane6YMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as tableH5H2EbVbSnEvogTPGQ3HPTwTDm5l773Vk5vRotQt3_450Meta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as APIDocsIqX7O6nORzsbynNZV_45KlzqEY2BK8gfQM49nVVZcHfU0Meta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabaseKngoOT_450BU5Z6Q0py0F_wTS7kRvrciacUDDDWVjSZXAMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formSL1Bk3f1WEAwj95SVSL1_kS3vOY0mwaB7gNz9QKb34kMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicViewwVCKT4gGprGXvHiveIUItgJilDn2DPaOCzPIc5l_45APUMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLogin2Vh_ZjtSVl5M25g_45l3FIT364Pa4KkP6otqMXhDpMXmoMeta } from "/var/www/baserow/baserow/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboardxpHtAHZzse7SknVrqK_45wJQh9gTZ4aAadCv0HDYZdFVkMeta } from "/var/www/baserow/baserow/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditorZaDpC1ybHWkWvOuhXlYDFaPWf9JEif_45_45JGcvCGGuJywMeta } from "/var/www/baserow/baserow/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPagemtA06Wg9SQP5Li_22tRYZPD2oYBOiRzbkSorwvfydqYMeta } from "/var/www/baserow/baserow/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflowyELdUjrMV3AOzbNHuxZobUCLv5NI3E_457BaADL9XwypMMeta } from "/var/www/baserow/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPages2_rQmbcC1vrj_zgkfZIrs_4npIvdjvcsJ6DRNZh_45AXAMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginXzFbQFoN0qZwLts5W3vfAeg2T05NsdmmtwmoGrbpnJ8Meta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupQCVimxnOy4SARnHC2r4P9kYjLnTSGki0Bpg_5ONmLUkMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordqzn3YZFmOUVO_9trW4Zyc_t0VOQjvHRYe_45qgoiWVjsIMeta || {},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddressexG3EQl6lRFA9KG9qpt7MMtzYVMwVAV2w1F3oo8RQ24Meta || {},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/styleGuide.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rootO78EjDlWRB58aLvJb4SZt_45g3x3OMxmAkyKy_45sOzDHBcMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardHmYdgJziaUC0eR2IytLRDnfiCVPH4LQMAC7Q7L5B26EMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspacewxZhMjbyofOljqfQuvSg8IYQDfk_A9io5UZZjIACBykMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(healthrB9qzLR_yuvkOkbO_45z1b0d_gMAaW1yAZXMzxV8NqUOQMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/settings/invites.vue")
  }
]
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingQHwVSXgnlyvQHccWhAEGxullQptF4c7t9AcooYfcTbMMeta || {},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tableH5H2EbVbSnEvogTPGQ3HPTwTDm5l773Vk5vRotQt3_450Meta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocsIqX7O6nORzsbynNZV_45KlzqEY2BK8gfQM49nVVZcHfU0Meta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLogin2Vh_ZjtSVl5M25g_45l3FIT364Pa4KkP6otqMXhDpMXmoMeta || {}), ...{"layout":"login"} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboardxpHtAHZzse7SknVrqK_45wJQh9gTZ4aAadCv0HDYZdFVkMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorZaDpC1ybHWkWvOuhXlYDFaPWf9JEif_45_45JGcvCGGuJywMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowyELdUjrMV3AOzbNHuxZobUCLv5NI3E_457BaADL9XwypMMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/var/www/baserow/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue")
  }
]